import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthImage from 'src/features/users/components/auth-image'
import Login from 'src/pages/login/login-page'
import { getLoggedInKey, getLoggedInRoleKey } from 'src/utils/browserStorage.util'



function LoginLayout() {
    const navigate = useNavigate()
    
    useEffect(() => {
        // If user is already logged in, redirect them away from login page
        const loggedIn = getLoggedInKey()
        const role = getLoggedInRoleKey()
        
        if (loggedIn && role && (role === "admin" || role === "employee")) {
            // Both admin and employee redirect to /statistics
            navigate("/statistics", { replace: true })
        }
    }, [navigate])
    
    return (
        <main className='bg-brand-50 p-4  h-dvh '>
            <div className='container flex_center mx-auto h-full'>
                <div className='flex-1 flex_center rounded-2xl items-stretch h-full overflow-hidden'>
                    <AuthImage></AuthImage>
                    <div className='bg-white flex-1'>
                        {/* because we have only the login feature , there is no need to use the <Outlet/> we directly import the page  */}
                        <Login></Login>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default LoginLayout
